import React from "react";
import {UsersIcon, EyeSlashIcon} from "@phosphor-icons/react";
import {ArrowUpRightIcon, ArrowDownRightIcon} from "@phosphor-icons/react/dist/ssr";
import { formatCurrency, formatPercent } from 'utilities/global.functions';

const TableRowCard = ({item, index, isAsset, isLiability, years, onItemClick, calculateProjection, formatTermRemaining}) => {
  const forecast = calculateProjection(item, years, isAsset);
  const valuation = Math.abs(item.valuation) * (item.ownership / 100);
  const growth = (((forecast - valuation) / valuation) * 100).toFixed(0);

  return (
    <div key={item.id || index} className="table-row" onClick={() => onItemClick && onItemClick(item)}>
      {/* FIRST COLUMN */}
      <div className="flex col small-gap">
        <div className="flex row small-gap center">
          <p className="medium  truncate-1">{item.name}</p>
          {item.ownership < 100 && (
            <div className="icon small">
              <UsersIcon />
            </div>
          )}
          {!item.include_networth && (
            <div className="icon small">
              <EyeSlashIcon />
            </div>
          )}
        </div>

        <p className="small o60">
          {formatCurrency(item.valuation)}
          {/* {isAsset && item.annual_contributions > 0 && `+${formatCurrency(item.annual_contributions)}`}
          {isLiability && formatTermRemaining(item.term_years, item.term_months, years)} */}
          &nbsp;
        </p>
      </div>

      {/* Growth/Interest Rate */}
      <div className="flex col center">
        {isAsset && item.annual_growth > 0 && <p className="tag regular"> {formatPercent(item.annual_growth)} </p>}
        {isLiability && item.interest_rate != 0 && <p className="tag regular"> {formatPercent(item.interest_rate)}</p>}
      </div>

 
       {/* Annual Contribution */}
      <div className="flex col center">
          {isAsset && item.annual_contributions > 0 && <p className="tag regular"> {formatCurrency(item.annual_contributions)} </p>} 
          {isLiability && formatTermRemaining(item.term_years, item.term_months, years)}
      </div>

      {/* Projection */}
      <div className="flex col center end  medium-gap">
        <p className="number medium">{formatCurrency(forecast)}</p>
        {growth > 0 && ( <div className="flag asset flex row center small-gap "> <ArrowUpRightIcon /> {formatPercent(growth)} </div> )}
        {growth < 0 && ( <div className="flag liability flex row center small-gap"> <ArrowDownRightIcon /> {formatPercent(growth)} </div> )}
              </div>

             {/* Growth Percentage Tag */}
      <div className="flex row end ">

      </div>



 
    </div>
  );
};

export default TableRowCard;
